import { GET_USER_APPS } from './gql/apps.list';
export const getUserAppsQuery = (gqlInstance, userId) => {
    return gqlInstance
        .getClient('graphqlClient')
        .query({
        query: GET_USER_APPS,
        fetchPolicy: 'network-only',
        variables: {
            userId,
        },
    })
        .then((response) => {
        return response.data.userApps;
    });
};
//# sourceMappingURL=apps.query.js.map